import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'

import { Card } from '../../../../../components'
import { getDetail, THEMES } from '../../../../../utils'

/**
 * Contact Name Component
 * @param props
 * @returns {*}
 * @constructor
 */
const Name = (props) => {
  const { name, nickName } = props

  return (
    <Card
      title='Name Detail'
      theme={THEMES.DARK_SLATE}>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <div className='card_section'>
            <div className='card_section-subtitle'>Name</div>
            <div className='card_section-detail'>{getDetail(name)}</div>
          </div>
        </Grid>
        <Grid item xs={4}>
          <div className='card_section'>
            <div className='card_section-subtitle'>Nickname</div>
            <div className='card_section-detail'>{getDetail(nickName)}</div>
          </div>
        </Grid>
      </Grid>
    </Card>
  )
}

Name.propTypes = {
  name: PropTypes.string,
  nickName: PropTypes.string,
}

export default Name
